<template>
  <div>
    <el-form-item
      class="form-color-item"
      :class="required"
      prop="name"
      :label="field.name + '：'"
      label-width="110px"
    >
      <!--<el-input disabled v-model="config[field.key]" :placeholder="field.memo"></el-input>-->
      <el-color-picker
        @change="headleChangeColor"
        :value="config[field.key]"
      ></el-color-picker>
    </el-form-item>
  </div>
</template>

<style lang="scss">
/*.form-color-item {*/
/*position: relative;*/
/*.el-color-picker {*/
/*position: absolute;*/
/*right: 1px;*/
/*top: 0px;*/
/*}*/
/*&:after {*/
/*content: '#';*/
/*font-size: 14px;*/
/*position: absolute;*/
/*left: 110px;*/
/*top: 9px;*/
/*}*/
/*}*/
</style>

<script>
/**
 * Created by huangdonglin on 2018/1/3.
 */
export default {
  name: "tms-type-color",
  props: {
    field: {
      type: [Object, Array],
      required: true,
    },
    source: {
      type: String,
    },
    // config: {
    //   type: Object,
    //   default() {
    //     return {}
    //   }
    // },
  },
  computed: {
    required() {
      if (this.field.required) {
        return "is-required";
      } else {
        return "";
      }
    },
    config() {
      if (this.source === "tmsPageConfig") {
        return this.$store.state.tms.pageData;
      }
      if (this.source === "tmsModuleConfig") {
        return this.$store.state.tms.config;
      }
      return this.$store.state.tms.customConfig;
    },
  },
  data() {
    return {};
  },

  components: {},

  mounted() {},

  methods: {
    headleChangeColor(color) {
      this.config[this.field.key] = color ? color : "";
    },
  },
};
</script>
